import api from "../../api";

function initialState() {
  return {
    newsletters: [],
    readNewsletters: [],
  };
}

const newslettersModule = {
  state: initialState,
  getters: {
    newsletters: (state) => state.newsletters,
    readNewsletters: (state) => state.readNewsletters,
  },
  mutations: {
    SET_NEWSLETTERS: function(state, newsletters) {
      state.newsletters = newsletters;
    },
    SET_NEWSLETTER_READ: function(state, newsletter) {
      if (!state.readNewsletters.find((a) => a === newsletter)) {
        state.readNewsletters = [...state.readNewsletters, newsletter];
      }
    },
    RESET_NEWSLETTERS: function(state) {
      const s = initialState();
      Object.keys(s).forEach((key) => {
        state[key] = s[key];
      });
    },
  },
  actions: {
    getNewsletters: function({ commit }, settings) {
      if (!this.getters.isLoading) {
        commit("SET_IS_LOADING", true);
      }
      api.newsletters
        .getNewsletters(
          settings.page,
          this.getters.appFilters.newsletterFilter,
          settings.itemsPerPage
        )
        .then((response) => {
          commit("SET_NEWSLETTERS", response);
        })
        .finally(() => {
          if (this.getters.isLoading) {
            commit("SET_IS_LOADING", false);
          }
        });
    },
    getIndividualNewsletter: function({ commit, state }, id) {
      return new Promise((resolve) => {
        const newsletter = state.newsletters.items.find(
          (newsletter) => newsletter.id === id
        );
        if (newsletter) {
          // commit("SET_INDIVIDUAL_NEWSLETTER", newsletter);
          resolve(newsletter);
        } else {
          if (!this.getters.isLoading) {
            commit("SET_IS_LOADING", true);
          }
          api.newsletters
            .getIndividualNewsletter(id)
            .then((response) => {
              resolve(response);
            })
            .finally(() => {
              if (this.getters.isLoading) {
                commit("SET_IS_LOADING", false);
              }
              resolve();
            });
        }
      });
    },
    setNewsletterRead: function({ commit }, id) {
      commit("SET_NEWSLETTER_READ", id);
    },
  },
};
export default newslettersModule;
